import { accountRoutes } from "@/modules/account/routes";
import { applicationRoutes } from "@/modules/application/routes";
import { authRoutes } from "@/modules/auth/routes";
import { beneficiaryRoutes } from "@/modules/beneficiary/routes";
import { bondRoutes } from "@/modules/bond/routes";
import { cardRoutes } from "@/modules/card/routes";
import { dashboardRoutes } from "@/modules/dashboard/routes";
import { depositRoutes } from "@/modules/deposit/routes";
import { exchangeRateRoutes } from "@/modules/exchangeRate/routes";
import { loanRoutes } from "@/modules/loan/routes";
import { stockRoutes } from "@/modules/stock/routes";
import { templateRoutes } from "@/modules/template/routes";
import { transactionRoutes } from "@/modules/transaction/routes";
import { AppPaths } from "@/shared/common/enums";
import { NotFound } from "@/shared/components";
import { createBrowserRouter } from "react-router-dom";

export const router = createBrowserRouter([
  {
    path: "/",
    handle: {
      breadcrumb: () => ({ key: "breadcrumb.dashboard" }),
    },
    children: [
      ...applicationRoutes,
      ...transactionRoutes,
      authRoutes,
      cardRoutes,
      loanRoutes,
      bondRoutes,
      stockRoutes,
      accountRoutes,
      depositRoutes,
      templateRoutes,
      dashboardRoutes,
      beneficiaryRoutes,
      exchangeRateRoutes,
    ],
  },
  {
    path: AppPaths.NotFound,
    element: <NotFound/>,
  },
]);

